import logger from '@adc/logger'
import { fetchDataForNewlyAuthenticatedUser as fetchUserData } from '../providers/user'
import {
  SAVE_USER,
  UPDATE_PROPERTIES_SAVED_STATE_FOR_NEWLY_AUTHENTICATED_USER,
} from '../constants/event.actionTypes'

export const initUser = user => ({
  type: SAVE_USER,
  value: user,
})

export const fetchDataForNewlyAuthenticatedUser =
  ({ user }) =>
  async (dispatch, getState) => {
    try {
      const currentlyLoadedPropertyIds = getState().assets.data.map(
        listing => listing.primary_property.property_id
      )

      const user = await fetchUserData({
        propertyIds: currentlyLoadedPropertyIds,
      })

      // NOTE: This data is all optional so by throwing here a handler can pick it up and do something smart
      if (!user) {
        throw new Error('No user data found')
      }

      /* eslint-disable-next-line */
      const { saved_property_lookup, ...standardUserShape } = user

      dispatch(initUser({ ...standardUserShape, logged_in: true }))

      dispatch({
        type: UPDATE_PROPERTIES_SAVED_STATE_FOR_NEWLY_AUTHENTICATED_USER,
        currently_saved_property_ids: Object.entries(saved_property_lookup)
          .filter(([, isSaved]) => isSaved)
          .map(([key]) => String(key)),
      })
    } catch (err) {
      logger.error(err)
      dispatch(initUser({ ...user, logged_in: true }))
    }
  }
